import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e463cb62&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e463cb62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e463cb62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e463cb62')) {
      api.createRecord('e463cb62', component.options)
    } else {
      api.reload('e463cb62', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e463cb62&scoped=true&", function () {
      api.rerender('e463cb62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/components/table-select/index.vue"
export default component.exports